import classNames from 'classnames';
import { ReactNode } from 'react';
import { classNameFromEnumValue } from '@steelbuy/util';
import { NotificationIllustratedAlignment } from './NotificationIllustrated.enums';
import iconSVG from '../../assets/lib-ui-primitive/icons/icon.svg';
import { IconIdentifier } from '../icon/Icon.enums';

import './NotificationIllustrated.scss';

export type NotificationIllustratedProps = {
    alignment: NotificationIllustratedAlignment;
    icon?: IconIdentifier;
    header?: string;
    helperText?: ReactNode;
    HelperComponent?: ReactNode;
    children?: ReactNode;
    className?: string;
};

export const NotificationIllustrated = (props: NotificationIllustratedProps) => {
    const { alignment, icon, header, helperText, children, HelperComponent, className } = props;

    const renderChildren = () => {
        if (children === undefined) {
            return null;
        }
        return <article className="notification-illustrated__text-wrapper__steps">{children}</article>;
    };

    return (
        <article
            className={classNames('notification-illustrated', className, {
                [classNameFromEnumValue(alignment, 'notification-illustrated')]: true,
            })}
        >
            {icon && (
                <div className="notification-illustrated__icon">
                    <svg>
                        <use href={`${iconSVG}#${icon}`} />
                    </svg>
                </div>
            )}
            <article className="notification-illustrated__text-wrapper">
                {header !== undefined && (
                    <span className="notification-illustrated__text-wrapper__header">{header}</span>
                )}
                {helperText !== undefined && (
                    <span className="notification-illustrated__text-wrapper__helper-text">{helperText}</span>
                )}
                {HelperComponent !== undefined && (
                    <div className="notification-illustrated__text-wrapper__helper-wrapper">{HelperComponent}</div>
                )}
                {renderChildren()}
            </article>
        </article>
    );
};
